import { create, StoreApi, UseBoundStore } from 'zustand'

type BannerStates = { [key: string]: boolean }

interface BannerStoreState {
  bannerStates: BannerStates
  bannersContainerId: string
}

interface BannerStoreActions {
  setBannerStates: (_bannerStates: BannerStates) => void
  setSingleBannerState: (_key: string, _value: boolean) => void
  setBannersContainerId: (_bannersContainerId: string) => void
  reset: () => void
}

type BannerStore = BannerStoreState & BannerStoreActions

const initialState: BannerStoreState = {
  bannerStates: {},
  bannersContainerId: '',
}

const useBannerStore: UseBoundStore<StoreApi<BannerStore>> = create((set) => ({
  ...initialState,

  setBannerStates: (newBannerStates: BannerStates) => {
    set((state) => ({
      ...state,
      bannerStates: { ...newBannerStates },
    }))
  },

  setSingleBannerState: (key: string, value: boolean) => {
    set((state) => ({
      ...state,
      bannerStates: {
        ...state.bannerStates,
        [key]: value,
      },
    }))
  },

  setBannersContainerId: (newBannersContainerId: string) => {
    set((state) => ({
      ...state,
      bannersContainerId: newBannersContainerId,
    }))
  },

  reset: () => {
    set(initialState)
  },
}))

// constants
const BANNER_KEY = {
  TRIAL_COUNTDOWN: 'trial_countdown',
  SOFT_LOCK: 'soft_lock',
  LIMIT_NOTIFICATION: 'limit_notification',
} as const

// selectors
const isBannerContainerMounted = (state: BannerStoreState) => !!state.bannersContainerId

export { useBannerStore, BANNER_KEY, isBannerContainerMounted }
